export enum DatasetType {
  Filesystem = 'FILESYSTEM',
  Volume = 'VOLUME',
}
